import BenchlingConfig from 'BenchlingConfig';
import {SchemaTag} from 'folder-items/FileConstants';
import {NoteLinkedPlateDesignNotePart} from 'notebook/integrations/plate-maps/plate-design/NoteLinkedPlateDesignTypes';
import {PlateDesignVersionRef} from 'samples/plate-maps/plate-record/PlateRecordConstants';
import {
  PlateDataParameter,
  PlateMap,
  SchematizedDisplayLayerMetadata,
} from 'samples/plate-maps/PlateMapConstants';
import {PlateMapValidation} from 'samples/plate-maps/validation/ValidationTypes';
import type {PlateSchema} from 'samples/storables/StorableSchemaConstants';

export enum PlateMapType {
  DESIGN = 'DESIGN',
  RECORD = 'RECORD',
}

export enum PlateDefinitionType {
  CREATE = 'CREATE',
  EXISTING = 'EXISTING',
}

export enum AnnotateFillPlateModalStep {
  DEFINE_PLATE = 'DEFINE_PLATE',
  DEFINE_PLATE_MAP = 'DEFINE_PLATE_MAP',
  DEFINE_TRANSFER = 'DEFINE_TRANSFER',
  TRANSFER_QUANTITIES = 'TRANSFER_QUANTITIES', // This is the `Review` step in the modal
}

export function getAnnotateFillPlateModalSteps(): Array<{
  key: AnnotateFillPlateModalStep;
  title: string;
  metadata?: string;
}> {
  return [
    {key: AnnotateFillPlateModalStep.DEFINE_PLATE, title: 'Select type'},
    {key: AnnotateFillPlateModalStep.DEFINE_PLATE_MAP, title: 'Define plate map'},
    ...(BenchlingConfig.INVENTORY_ENABLE_PLATE_CONCENTRATION_LAYER
      ? [
          {key: AnnotateFillPlateModalStep.DEFINE_TRANSFER, title: 'Define transfer'},
          {key: AnnotateFillPlateModalStep.TRANSFER_QUANTITIES, title: 'Review'},
        ]
      : [{key: AnnotateFillPlateModalStep.TRANSFER_QUANTITIES, title: 'Define transfer'}]),
  ];
}

export interface DefineExistingPlateState {
  selectedGridId: string | null;
  isValidating: boolean;
  error: string | null;
  tags: Array<SchemaTag>;
  appendStudyIds: Array<string>;
}

export interface PlateDesignState {
  plateSchema: PlateSchema | null;
  name?: string | null;
}

export interface InitiatingPlateDesignState {
  plateMap: PlateMap;
  plateDesignState: PlateDesignState;
  plateMapStalenessValidation: PlateMapValidation;
  selectedPlateDataParameterIds: Set<string>;
  wellSchemaOptions: Array<SchematizedDisplayLayerMetadata>;
  /**
   * If PlateMapType.DESIGN, we are editing the existing plate design.
   * If PlateMapType.RECORD, we are creating a plate record from the existing plate design.
   */
  plateMapType: PlateMapType;
  plateDesignVersionRef: PlateDesignVersionRef;
  plateDataParameters: Array<PlateDataParameter>;
}

export type InitiatingPlateDesignStateWithNotePart = InitiatingPlateDesignState & {
  plateDesignNotePart: NoteLinkedPlateDesignNotePart;
};
